export default __webpack_public_path__ + "static/media/welcome_chat_bg.f0a7f23e.png";